import { Button } from "~/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function LiftingOperationsPage() {
  const navigate = useNavigate();

  return (
    <div className="flex h-[400px] flex-col items-center justify-center space-y-4 pt-20">
      <h1 className="text-2xl font-bold text-gray-700">Lifting Operations</h1>
      <p className="text-gray-500">
        This module is currently under development.
      </p>
      <Button onClick={() => navigate("/daily-ops")} variant="outline">
        Go Back
      </Button>
    </div>
  );
}
